export enum RadioButtonSize {
  NORMAL = 'normal',
  SMALL = 'small',
  MEDIUM = 'medium',
}
